/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'text/usd': {
    width: 36,
    height: 22,
    viewBox: '0 0 36 22',
    data: '<path pid="0" d="M2.074 12.016c0 2.195 1.188 3.582 3.402 3.582 2.214 0 3.401-1.387 3.402-3.582V4.707h1.494v7.326c0 2.988-1.638 4.897-4.896 4.897S.58 15.004.58 12.052V4.707h1.494v7.309zm14.89-7.489c1.835 0 3.257.612 4.265 1.674l-.9 1.099c-.9-.99-2.16-1.44-3.474-1.44-1.44 0-2.466.774-2.466 1.908 0 2.7 7.11 1.151 7.11 5.633 0 1.746-1.188 3.529-4.428 3.529-2.088 0-3.618-.793-4.608-1.909l.882-1.133c.792.882 2.089 1.71 3.78 1.71 2.142 0 2.826-1.153 2.826-2.07 0-3.097-7.11-1.387-7.11-5.67 0-1.98 1.764-3.33 4.123-3.33zm10.87.18c3.726 0 6.156 2.61 6.156 6.013 0 3.42-2.43 5.993-6.156 5.993H23.73V4.707h4.104zm-2.61 10.674h2.61c2.916 0 4.608-2.087 4.608-4.661 0-2.592-1.638-4.68-4.608-4.68h-2.61v9.34z" _fill="#0077C8"/>'
  }
})
